import Splide from '@splidejs/splide';
import Page from '../page';
import { scrollToYOffset } from '../../helpers/scroll-to-helper';

export default class CmsPage extends Page {
  bind() {
    this._initializeFormScrollToEvent(); // todo : reusable widget ?
    this._initializeLazyLoading(); // todo : move that to global ?
    this._initializeLinkedPagesSlider(); // todo : move that to global ?
  }

  _initializeFormScrollToEvent() {
    const anchor = document.body.querySelector('#formulaire');
    if (!anchor) {
      return;
    }

    const links = document.body.querySelectorAll('a[href="#formulaire"]');
    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        scrollToYOffset(anchor.getBoundingClientRect().top + window.scrollY);
      });
    });
  }

  _initializeLinkedPagesSlider() {
    const sliderElement = document.getElementById('linked-pages-slider');
    if (!sliderElement) {
      return;
    }
    if (this._isMobile === true) {
      new Splide(sliderElement, {
        type: 'loop',
        pagination: false,
        arrows: false,
        padding: { left: 70, right: 70 },
        gap: 20,
        focus: 'center',
      }).mount();
      return;
    }
    new Splide(sliderElement, {
      type: 'loop',
      perPage: (window.innerWidth > 1200) ? 3 : 2,
      perMove: 1,
      pagination: false,
      padding: { left: 70, right: 70 },
      gap: 20,
    }).mount();
  }
}
